(function() {
  'use strict';

  angular
    .module('observatoireApp')
    .controller('AutorisationsMinieresDetailsCtrl', AutorisationsMinieresDetailsCtrl);

  /** @ngInject */
  AutorisationsMinieresDetailsCtrl.$inject = ['$scope', '$stateParams', 'AutorisationsMinieresService', 'MetaService'];
  function AutorisationsMinieresDetailsCtrl($scope, $stateParams, AutorisationsMinieresService, MetaService) {
    // Variables du scope
    $scope.autorisationMiniere = null;
    $scope.isLoading = true;
    $scope.error = null;
    
    // Initialiser
    initialize();
    
    function initialize() {
      // Récupérer l'ID depuis les paramètres de l'URL
      var autorisationId = $stateParams.id;
      
      if (!autorisationId) {
        $scope.error = "ID d'autorisation minière manquant";
        $scope.isLoading = false;
        return;
      }
      
      // Charger les détails de l'autorisation minière
      loadAutorisationMiniereDetails(autorisationId);
    }
    
    function loadAutorisationMiniereDetails(id) {
      $scope.isLoading = true;
      console.log('Chargement des détails de l\'autorisation minière avec ID:', id);
      
      AutorisationsMinieresService.getAutorisationMiniereById(id)
        .then(function(data) {
          console.log('Données d\'autorisation reçues:', data);
          $scope.autorisationMiniere = data;
          
          // Mettre à jour le titre de la page
          if (data && data.numeroAutorisation) {
            MetaService.setTitle('Autorisation minière - ' + data.numeroAutorisation);
          } else {
            MetaService.setTitle('Détails de l\'autorisation minière');
          }
          
          // Initialiser la carte si des coordonnées sont disponibles
          if (data && data.latitude && data.longitude) {
            setTimeout(function() {
              initMap(data);
            }, 100);
          }
          
          $scope.isLoading = false;
        })
        .catch(function(error) {
          var errorMessage = '';
          if (error && error.data) {
            errorMessage = error.data.message || error.data;
          } else if (error && error.status) {
            errorMessage = 'Erreur HTTP ' + error.status + ': ' + (error.statusText || 'Erreur inconnue');
          } else {
            errorMessage = 'Erreur inconnue';
          }
          
          console.error('Erreur lors du chargement des détails de l\'autorisation minière', error, errorMessage);
          $scope.error = "Impossible de charger les détails de l'autorisation minière: " + errorMessage;
          $scope.isLoading = false;
        });
    }
    
    function initMap(autorisation) {
      // Vérifier si Leaflet est disponible
      if (typeof L === 'undefined') {
        console.error("Leaflet n'est pas chargé");
        return;
      }
      
      // Vérifier que le conteneur de carte existe
      var mapContainer = document.getElementById('details-map');
      if (!mapContainer) {
        console.error("Le conteneur de carte n'existe pas");
        return;
      }
      
      try {
        // Initialiser la carte
        var map = L.map('details-map').setView([autorisation.latitude, autorisation.longitude], 10);
        
        // Ajouter la couche de tuiles OpenStreetMap
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
          attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        }).addTo(map);
        
        // Ajouter un marqueur pour l'autorisation
        var marker = L.marker([autorisation.latitude, autorisation.longitude])
          .bindPopup(
            '<strong>' + (autorisation.numeroAutorisation || 'No. inconnu') + '</strong><br>' +
            'Type: ' + (autorisation.typeAutorisation || 'Non spécifié') + '<br>' +
            'Société: ' + (autorisation.societe || 'Non spécifiée') + '<br>' +
            'Substance: ' + (autorisation.substance || 'Non spécifiée')
          )
          .addTo(map)
          .openPopup();
        
        // Forcer le redimensionnement de la carte pour corriger les problèmes d'affichage
        setTimeout(function() {
          map.invalidateSize();
        }, 500);
      } catch (error) {
        console.error("Erreur lors de l'initialisation de la carte", error);
      }
    }
    
    // Formater une date pour l'affichage
    $scope.formatDate = function(dateValue) {
      if (!dateValue) {
        return 'Date inconnue';
      }
      
      var date;
      
      // Vérifier si la date est au format tableau
      if (Array.isArray(dateValue) && dateValue.length >= 3) {
        // Tableau [année, mois, jour, ...]
        var year = dateValue[0];
        var month = dateValue[1] - 1; // Ajuster le mois pour JavaScript (0-11)
        var day = dateValue[2];
        var hours = dateValue.length > 3 ? dateValue[3] : 0;
        var minutes = dateValue.length > 4 ? dateValue[4] : 0;
        
        date = new Date(year, month, day, hours, minutes);
      } else {
        // Essayer de parser normalement
        date = new Date(dateValue);
      }
      
      if (isNaN(date.getTime())) {
        return 'Date invalide';
      }
      
      return date.toLocaleDateString('fr-FR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      });
    };
  }
})();
